import script from "./RiskRatingForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./RiskRatingForm.vue?vue&type=script&lang=ts&setup=true"

import "./RiskRatingForm.vue?vue&type=style&index=0&id=d8c02f90&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8c02f90"]])

export default __exports__